import React, { useEffect, useState } from "react";
import ChatbotIcon from "./ChatbotIcon";
import ChatWindow from "../pages/ChatWindow";
import { getWidgetsInfo } from "../api-services/company.api";
import useChatStore from "../store/useChatStore";

const ChatbotApp = () => {
  const { setChatbotTheme } = useChatStore();

  const shopUrl = window.location.href;
  const domain = new URL(shopUrl).host;

  const [isChatOpen, setIsChatOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isIconOpen, setIsIconOpen] = useState(true);

  const toggleChat = () => {
    setIsChatOpen(!isChatOpen);
    setIsIconOpen(!isIconOpen);
  };

  const closeChat = () => {
    setIsChatOpen(false);
    setIsIconOpen(true);
  };

  const getChatbotTheme = () => {
    const params = {
      shopID: domain === "localhost:3000" ? "sulopa.myshopify.com" : domain,
    };
    getWidgetsInfo(params).then((res) => {
      if (res?.message === "Successful") {
        setChatbotTheme(res?.payload?.widges?.colorTheme || "#003C84");
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    getChatbotTheme();
  }, []);

  if (loading) {
    return null;
  }

  return (
    <>
      {isChatOpen && <ChatWindow closeChat={closeChat} />}
      {isIconOpen && <ChatbotIcon toggleChat={toggleChat} />}
    </>
  );
};

export default ChatbotApp;
